module.exports = __webpack_public_path__ + "img/boy-bird.c2a2e4d7.png";